import { Extension } from "@tiptap/core";

const DIR_TYPES = [
  "paragraph",
  "heading",
  "blockquote",
  "bulletList",
  "orderedList",
  "listItem",
  "taskList",
  "taskItem",
  "codeBlock",
];

export const OptionalDir = Extension.create({
  name: "optionalDir",

  addGlobalAttributes() {
    return [
      {
        types: DIR_TYPES,
        attributes: {
          dir: {
            default: null,
            parseHTML: (element) => {
              const value = element.getAttribute("dir");
              return value === "rtl" || value === "ltr" || value === "auto"
                ? value
                : null;
            },
            renderHTML: (attributes) =>
              attributes.dir ? { dir: attributes.dir } : {},
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setTextDirection:
        (direction) =>
        ({ commands, editor }) => {
          const active = DIR_TYPES.find((type) => editor.isActive(type));
          if (!active) return false;
          return commands.updateAttributes(active, { dir: direction });
        },
    };
  },
});
